import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {Grid, Header, Button, Dropdown, Modal, Image } from 'semantic-ui-react';
import axiosRetry from "axios-retry";
// import CircleLoader from "./circle-loader/CircleLoader";

const origin = window.location.origin;

export default class FISelection extends Component {

    state = {
        selectedFI : '',
        open: false,
        signingIn: false,
        success: false,
        fis: [],
        pending: false,
        userClosed: false,
        loadComplete: false,
        register: true,
        error: false,
        errMsg: ""
    };

    handleChange = (e, { name, value }) => {
        const { fis } = this.state;
        let selected = fis.find(institute => institute.value === value);
        this.setState({selectedFI: selected});
    };

     handleContinue = () => {
        const { selectedFI } = this.state;
        const { env } = this.props;
        this.setState({pending: true, error: false, userClosed: false, register: true});

        if(selectedFI !== null){
            const callback = encodeURI(origin + "/redirect");
            // Fixes dual-screen position                         Most browsers      Firefox
            let dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            let dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

            let width = window.innerWidth;
            let height = window.innerHeight;

            let left = ((width / 2) - (900 / 2)) + dualScreenLeft;
            let top = ((height / 2) - (800 / 2)) + dualScreenTop;
            let finalCallback = origin === "http://localhost:3000" ? "https://localhost:8081/__login/" : "/__login/";
            let popup = window.open(finalCallback + selectedFI.value + "/" + env + "?callback_url=" + callback, 'newwindow', 'height=800,width=900,top=' + top + ',left=' + left);
            let timer = setInterval(() => {
                if (popup.closed) {
                    clearInterval(timer);
                    this.setState({pending: false, userClosed: true});
                }
            }, 500);
            if (window.focus) {popup.focus();}

        }else{
            console.log("No FI selected.");
        }
    };

    componentDidMount() {
        // this.props.updateAuth(true);
        if (this.state.fis.length === 0 || this.props.env !== localStorage.getItem('env')) {
            axios.get('/api/fis/' + this.props.env).then(res => {
                if (res.data) {
                    this.setState({fis: res.data});
                }
            });
        }
        window.addEventListener("message", (e) => {
            console.log(e);
            if (e.origin !== origin) {
                console.log('bad origin');
                return;
            }

            if (e.data === 'success') {
                axiosRetry(axios, { retries: 3});
                axiosRetry(axios, { retryDelay: (retryCount) => {
                        console.log("retrying...");
                        return retryCount * 4000;
                    }});
                axios.get('/api/accountdetails/' + this.props.env).then(res => {
                    if (res.data) {
                        this.setState({loadComplete: true});
                    }
                });
                this.setState({success: true, register: false});
            } else if (e.data === 'cancel') {
                this.setState({register: false, error: true, errMsg: "You canceled the linking process."})
            } else if (e.data === 'error') {
                this.setState({register: false, error: true, errMsg: "There was an error during the linking process."})
            }
        });
    }

    show = () => this.setState({open: true, register: true});

    close = () => this.setState({open: false, pending: false, error: false, userClosed: false});

    render() {

        const { selectedFI, open, success, fis, pending, userClosed, register, error, errMsg } = this.state;

        return (
            <Grid centered stackable columns={2}>
                <Grid.Column>
                    <Header as='h2' className='hooli-header'>
                        <div className='hooli-text-dark-blue'>One place for all of your accounts</div>
                        <Header.Subheader>
                            Find your institution and add it to get a better view of your financial picture.
                        </Header.Subheader>
                    </Header>
                    <Dropdown placeholder='Select Financial Institute'
                              fluid search selection
                              options={fis}
                              onChange={this.handleChange}
                              data-it="fi-dropdown" />
                    <div className='hooli-btn-group hooli-centered'>
                        <Button className='hooli-btn-select' onClick={this.show} disabled={selectedFI === ''}>
                            Continue
                        </Button>
                        <Modal
                            className='hooli-centered hooli-modal'
                            centered={true}
                            open={open}
                            closeOnEscape={false}
                            closeOnDimmerClick={true}
                            dimmer='blurring'
                            size='tiny'>
                            {success &&
                                <Modal.Content>
                                    <div className='hooli-centered-margin'>
                                        {/*<CircleLoader done={loadComplete}/>*/}
                                        <Image src='/img/check.png' size='small' className='hooli-centered-margin'/>
                                    </div>
                                    <Header as='h1' className='hooli-modal-header'>Success!</Header>
                                    <div className='hooli-modal-content'>Your accounts have been linked!</div>
                                    <div className='hooli-btn-group'>
                                        <Link to='/home'>
                                            <Button className='hooli-btn-select'>Go to Overview</Button>
                                        </Link>
                                    </div>
                                </Modal.Content>
                            }
                            {register &&
                                <Modal.Content>
                                    {pending ? (<Header as='h1' className='hooli-modal-header'>Please wait while we retrieve your account information.</Header>) :
                                        (userClosed ?
                                                <Header as='h1' className='hooli-modal-header'>You did not complete the linking process. Press 'Sign in' to continue.</Header>
                                                :
                                                <div>
                                                    <Header as='h1' className='hooli-modal-header'>Connect securely to {selectedFI.text}</Header>
                                                    <div className='hooli-modal-content'>You are being securely redirected to {selectedFI.text}.</div>
                                                </div>
                                        ) }
                                    <div className='hooli-btn-group'>
                                        <Button className='hooli-btn-select' onClick={this.handleContinue}>Sign In</Button>
                                        <Button className='hooli-btn-primary-inverted' onClick={this.close}>Cancel</Button>
                                    </div>
                                </Modal.Content>
                            }
                            {error &&
                                <Modal.Content>
                                    <Header as='h1' className='hooli-modal-header'>{errMsg}</Header>
                                    <div className='hooli-modal-content'>Press 'Sign in' to try again or 'Cancel' to exit.</div>
                                    <div className='hooli-btn-group'>
                                        <Button className='hooli-btn-select' onClick={this.handleContinue}>Sign In</Button>
                                        <Button className='hooli-btn-primary-inverted' onClick={this.close}>Cancel</Button>
                                    </div>
                                </Modal.Content>
                            }
                        </Modal>
                    </div>
                </Grid.Column>
            </Grid>
        )

    }

}
